import { useEffect, useState } from "react";
import { NavLink as Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Logo } from "@/components/Logo";
import { useLenis, scrollToTarget } from "@/components/LenisProvider";
import { Button } from "@/components/ui/button";

const LINKS = [
  { id: "packages", label: "Packages" },
  { id: "gallery", label: "Gallery" },
  { id: "about", label: "About" },
  { id: "faq", label: "FAQ" },
];

const NAV_VARIANT = "nav-link";

export default function Nav() {
  const [open, setOpen] = useState(false);
  const lenis = useLenis();

  const go = (e, id) => {
    e.preventDefault();
    setOpen(false);
    scrollToTarget(lenis, `#${id}`);
  };

  return (
    <header className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-black/60 border-b border-white/10">
      <div className="mx-auto max-w-7xl px-5 md:px-10 h-16 md:h-20 flex items-center justify-between">
        <a
          href="/"
          data-testid="nav-logo"
          onClick={(e) => {
            e.preventDefault();
            setOpen(false);
            if (lenis) lenis.scrollTo(0, { immediate: true });
            else window.scrollTo(0, 0);
          }}
        >
          <Logo />
        </a>

        <nav className="hidden md:flex items-center gap-10">
          {LINKS.map((l) => (
            <a
              key={l.id}
              href={`#${l.id}`}
              data-testid={`nav-${l.id}-link`}
              onClick={(e) => go(e, l.id)}
              className="text-sm text-[#A3A3A3] hover:text-[#F5F5F5] transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
          <Button
            data-testid="nav-book-button"
            onClick={(e) => go(e, "booking")}
            className="rounded-sm bg-[#D98B48] hover:bg-[#F0A562] text-[#090909] font-medium px-6"
          >
            Book Now
          </Button>
        </nav>

        <button
          className="md:hidden text-[#F5F5F5] p-2 -mr-2"
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-[#090909]/95 backdrop-blur-xl border-b border-white/10">
          <nav className="px-6 py-6 flex flex-col gap-5">
            {LINKS.map((l) => (
              <a
                key={l.id}
                href={`#${l.id}`}
                data-testid={`nav-mobile-${l.id}-link`}
                onClick={(e) => go(e, l.id)}
                className="font-display text-2xl text-[#F5F5F5]"
              >
                {l.label}
              </a>
            ))}
            <Button
              data-testid="nav-mobile-book-button"
              onClick={(e) => go(e, "booking")}
              className="rounded-sm bg-[#D98B48] hover:bg-[#F0A562] text-[#090909] font-medium w-full"
            >
              Book Now
            </Button>
          </nav>
        </div>
      )}
    </header>
  );
}
